<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="its-all-an-act">
<p style="text-indent:00em; padding-top:70px;"><em>It's All an Act</em> is essential reading for anyone working with young people. The text is jam-packed with practical tips for behaviour management that can be applied to any classroom context and that will ensure that your students work with you. Jim Wood’s ethos is not the tradition of fear and punitive sanctions, but instead he has a mantra of engendering mutual respect and high expectations within the learning environment. His practical strategies will allow you to go further with young people’s learning than others might think is possible, and do so with a quiet and controlled authority. Alongside this, his writing style is very readable and he laces his ideas with anecdotes shared from his many successful years of working with adolescents. Whether you are a teacher who is brand new to the classroom, or, (like me), someone with more than twenty years’ worth of experience, his strategies will help every teacher to unlock the potential of the young people in their care. I was gripped from the start to the end and have applied some of his ideas already. Thank you Jim for sharing your vast experience and expertise with the profession, I know that this book will help us all!</p><br/>
<p style="text-indent:00em">Mrs A. Eagle.</p>
<p style="text-indent:00em">Headteacher,</p>
<p style="text-indent:00em">The Romsey School.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?72774945